import { Box, Card, Heading, Icon, Modal, PropertyCard, Text, TextButton } from '@zillow/constellation-10';

import type { ElementType } from 'react';

type FeatureCardProps = {
  heading: string;
  body: string;
  Icon: ElementType;
  modalContent: string;
  headingCount?: string | null;
};

const FeatureCard = ({ heading, body, Icon: IconComponent, modalContent, headingCount = null }: FeatureCardProps) => {
  const updatedHeading = headingCount ? `${headingCount} ${heading}` : heading;

  return (
    <>
      <Box css={{ display: 'grid', gridColumnEnd: { base: 'span 4', xl: 'span 1' } }} data-testid="FeatureCard">
        <Modal
          dividers={false}
          trigger={
            <Card outlined={false} interactive={true} elevated={true} tone="neutral">
              <Box css={{ display: 'flex', height: '100%', flexDirection: 'column' }}>
                <Box css={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Text textStyle="body-bold" asChild>
                    <p>{updatedHeading}</p>
                  </Text>
                  <Icon size="md" css={{ color: 'icon.action.hero.default' }} render={<IconComponent />} />
                </Box>
                <Box css={{ display: 'flex', flexGrow: 1 }}>
                  <Text asChild css={{ marginBlock: '200' }}>
                    <p>{body}</p>
                  </Text>
                </Box>
                <Box css={{ display: 'flex' }}>
                  <TextButton textStyle="body-sm">Learn more</TextButton>
                </Box>
              </Box>
            </Card>
          }
          body={
            <>
              <Box css={{ display: 'flex', justifyContent: 'center', marginBottom: '400' }}>
                <Box css={{ overflow: 'hidden', borderRadius: 'obj.default', width: '200px', height: '150px' }}>
                  <PropertyCard.Photo
                    alt="house"
                    fallbackImg={<PropertyCard.PhotoFallback />}
                    css={{ width: '200px', height: '150px' }}
                  />
                </Box>
              </Box>
              <Heading level={2} css={{ marginBottom: '400' }}>
                {heading}
              </Heading>
              <Text>{modalContent}</Text>
            </>
          }
        />
      </Box>
    </>
  );
};

export { FeatureCard };
